<template>
  <div>
    <Breadcrumbs main="Contact Center Portal" title="Email Template" />
    <div class="container-fluid">
      <div class="d-flex justify-content-end m-3">
        <b-button v-if="!edit" variant="primary" class="btn-pill mx-2" @click="openModal('Add')">
          <i class="icofont icofont-plus-circle"></i> Add New</b-button>
        <b-button v-if="edit" variant="success" class="btn-pill"
          @click="confirmAlert('Confirm to update number ?', 'update number')">
          <i class="fa fa-check"></i> Complete</b-button>
        <b-button v-if="edit" variant="danger" class="btn-pill" @click="edit = !edit">
          <i class="fa fa-check"></i> Cancel</b-button>
        <b-button v-if="!edit" variant="warning" class="text-dark btn-pill" @click="onloadFolder">
          <i class="icofont icofont-ui-edit"></i> Edit</b-button>
      </div>
      <ValidationObserver v-slot="{ invalid }">
        <b-modal size="xl" :hide-footer="modalData.title == 'View'" content-class="rounded-1" v-model="show"
          body-class="p-4" centered :title="`${modalData.title} Template`">
          <div class="row">
            <div v-for="(form, i) in form" :key="i" :class="`col-${form.col}`">
              <ValidationProvider :name="form.name" :rules="form.name.match('No')
                                ? 'required|numeric'
                                : form.validate
                                  ? form.rule
                                  : null
                              " v-slot="{ errors }">
                <b-form-group :label="form.name" :label-for="form.name">
                  <template #description>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </template>
                  <v-select v-if="form.type.match('select')" :id="form.name" :disabled="modalData.disable"
                    v-model="form.value" label="name" :options="folder"></v-select>

                  <!-- <vue-editor
                    style="font-family: Tahoma; font-size: 10px"
                    v-else-if="form.type.match('editor')"
                    v-model="form.value"
                    :disabled="modalData.disable"
                    @focus="code = i"
                    :editor-toolbar="customToolbar"
                  ></vue-editor> -->
                  <quill-editor :class="modalData.disable ? 'headerDisable' : ''" :style="modalData.disable
                                        ? 'background-color:#e9ecef;font-family: Tahoma; font-size: 10px;'
                                        : 'font-family: Tahoma; font-size: 10px;'
                                      " v-else-if="form.type.match('editor')" v-model="form.value" :disabled="modalData.disable"
                    @focus="code = i" :options="editorOption"></quill-editor>
                  <b-button v-else-if="form.type.match('file')" v-b-modal="'modal-attachments-file'"
                    variant="primary">Attachments({{
                                        attachments.length + new_attachments.length
                                        }})</b-button>
                  <b-form-input v-else :disabled="modalData.disable" :id="form.name" v-model="form.value"></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </div>
          </div>
          <template #modal-footer>
            <b-button variant="primary" :disabled="invalid" @click="onSave(modalData)"><i class="fa fa-save"></i> Save
            </b-button>
          </template>
        </b-modal>
        <!--  -->
        <!-- Vertically centered Modal Component -->
        <b-modal id="modal-attachments-file" size="lg" centered title="Attachments" hide-footer class="theme-modal">
          <div class="file-content">
            <div class="card">
              <div class="" v-if="modalData.title != 'View'">
                <div class="media">
                  <div class="media-body text-right">
                    <div class="btn btn-outline-primary ml-2" @click="openUpload">
                      <feather type="upload" class="text-top"></feather> Upload
                    </div>
                    <input @change="addFile" ref="fileUpload" type="file" hidden />
                  </div>
                </div>
              </div>
              <div class="card-body file-manager">
                <template v-if="attachments.length > 0">
                  <h6>Files</h6>
                  <ul class="files">
                    <li class="file-box" v-for="(n, index) in attachments" :key="index">
                      <div class="file-top">
                        <i class="fa fa-file-archive-o txt-secondary"></i>
                        <i class="fa fa-times f-14 text-danger ellips" @click="removeAttachment(index)"
                          v-if="modalData.title != 'View'"></i>
                      </div>
                      <div class="file-bottom">
                        <h6>{{ n.name }}</h6>
                        <p class="mb-1">{{ formatBytes(n.size) }}</p>
                        <p>
                          <a href="javascript:void(0)" @click="
                                                      downloadFile(
                                                        n.name,
                                                        n.contentType,
                                                        n.contentBytes,
                                                        n.size,
                                                        n.from,
                                                        n.mail_id
                                                      )
                                                      ">Download</a>
                        </p>
                      </div>
                    </li>
                  </ul>
                </template>
                <template v-if="modalData.title != 'View' && new_attachments.length > 0">
                  <h6 class="mt-3">Add Files</h6>
                  <ul class="files">
                    <li class="file-box" v-for="(n, index) in new_attachments" :key="index">
                      <div class="file-top">
                        <i class="fa fa-file-archive-o txt-secondary"></i>
                        <i class="fa fa-times f-14 text-danger ellips" @click="removeNewAttachment(index)"></i>
                      </div>
                      <div class="file-bottom">
                        <h6>{{ n.name }}</h6>
                        <p class="mb-1">{{ formatBytes(n.size) }}</p>
                        <p>
                          <a href="javascript:void(0)" @click="
                                                      downloadFile(
                                                        n.name,
                                                        n.contentType,
                                                        n.contentBytes,
                                                        n.size,
                                                        n.from,
                                                        n.mail_id
                                                      )
                                                      ">Download</a>
                        </p>
                      </div>
                    </li>
                  </ul>
                </template>
              </div>
            </div>
          </div>
        </b-modal>
        <!--  -->
      </ValidationObserver>
      <div class="card p-4">
        <div v-if="edit">
          <table class="table table border">
            <thead>
              <tr>
                <template v-for="(col, i) in columns.slice(0, 5)">
                  <th :key="i" scope="col" class="h6" v-if="col.field != 'no' && col.field != 'mail_folder'">
                    {{ col.label }}
                  </th>
                </template>
              </tr>
            </thead>
            <draggable v-model="templateList" tag="tbody">
              <tr v-for="(item, j) in templateList" :key="j" class="row-table" style="cursor: all-scroll">
                <!-- <td scope="row">{{ item.no }}</td> -->
                <td scope="row">{{ item.name }}</td>
                <!-- <td scope="row">{{ item.mail_folder }}</td> -->
                <td scope="row">
                  {{ item.created_at | moment('YYYY-MM-DD, kk:mm ') }}
                </td>
                <td scope="row">
                  {{ item.updated_at | moment('YYYY-MM-DD, kk:mm ') }}
                </td>
              </tr>
            </draggable>
          </table>
        </div>
        <dataTableVue v-else ref="refDataTable" :isSearch="false" :isExport="true" :isFilter="true" :isImport="true"
          v-bind:data="{
                      module: 'ccp',
                      columns: columns,
                      rows: rows,
                      exportDetail: exportDetail,
                      importDetail: importDetail,
                      filter_custom: 'filterCustomTemplate',
                    }" @load="loadItems" @openModal="openModal" @deleteRow="deleteRow" />
      </div>
    </div>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor';

import { requestService } from './../../_services';
import Quill from 'quill';
import ImageResize from 'quill-image-resize-vue';
Quill.register('modules/imageResize', ImageResize);

export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' },
        ],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ['clean'], // remove formatting button
      ],
      editorOption: {
        modules: {
          //imageDrop: true,
          // imagePaste: true,
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ direction: 'rtl' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            // [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ['clean'],
            ['link', 'image', 'video'],
            ['template-partediario'],
          ],
          imageResize: {
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white',
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar'],
          },
        },
      },
      edit: false,
      folder: [],
      modalData: {
        title: null,
        disable: false,
        row: null,
      },
      show: false,
      form: [
        {
          value: '',
          col: 6,
          name: 'Name',
          type: 'input',
          validate: true,
          rule: 'required|customRegex|customRegexCRLF|max_length200',
        },
        {
          value: '',
          col: 6,
          name: 'Folder',
          type: 'select',
          validate: true,
          rule: 'required|customRegex|customRegexCRLF|max_length200'
        },
        {
          value: '',
          col: 12,
          name: 'Subject',
          type: 'input',
          validate: true,
          rule: 'required|customRegex|customRegexCRLF|max_length200'
        },
        {
          value: '',
          col: 4,
          name: 'Attachments',
          type: 'file',
          validate: false,
        },
        {
          value: '',
          col: 12,
          name: 'Message',
          type: 'editor',
          validate: true,
          rule: 'required'
        },
      ],
      rows: [],
      columns: [
        {
          label: 'No',
          field: 'no',
          hidden: false,
        },
        {
          label: 'Template Name',
          field: 'name',
          hidden: false,
        },
        {
          label: 'Folder Name',
          field: 'mail_folder',
          hidden: false,
        },
        {
          label: 'Created',
          field: 'created_at',
          hidden: false,
        },
        {
          label: 'Updated',
          field: 'updated_at',
          hidden: false,
        },
        {
          label: 'Action',
          field: 'action',
          thClass: 'custom-th-class',
          hidden: false,
        },
      ],
      importDetail: {
        importUrl: '/api/mail/template/import/all',
        importField: [
          {
            key: 'no',
            isFind: null,
          },
          {
            key: 'name',
            isFind: null,
          },
          {
            key: 'mail_folder',
            isFind: null,
          },
          {
            key: 'subject',
            isFind: null,
          },
          {
            key: 'body',
            isFind: null,
          },
        ],
      },
      exportDetail: {
        fileName: 'export_template',
        exportUrl: '',
      },
      attachments: [],
      new_attachments: [],
      templateList: [],
    };
  },
  watch: {
    show(newValue, oldValue) {
      if (oldValue) {
        this.form.map((item, i) => {
          this.form[i].value = '';
        });
      }
    },
  },
  async created() {
    await this.folderOption();
    await this.loadItems();
  },

  methods: {
    processTags(e) {
      console.log('processTags', e);
    },
    async templateOption() {
      let url = `/api/mail/template/all`;
      const resFolder = await requestService.GetFetch('ccp', url);
      const folder = await resFolder.json();
      this.templateList = folder.data;
    },
    async onloadFolder() {
      this.edit = !this.edit;
      await this.templateOption();
    },
    confirmAlert(title, type) {
      this.$swal
        .fire({
          title: title,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2971FF',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
          camcelButtonText: 'Cancel',
        })
        .then((result) => {
          if (result.isConfirmed) {
            switch (type) {
              case 'update number':
                this.onUpdateNumber();
                break;
            }
          }
        });
    },
    onUpdateNumber() {
      const url = `/api/mail/template/convert/number`;
      var arr = [];
      this.templateList.forEach((element, index) => {
        let obj = {
          template_id: element._id,
          no: index + 1,
        };
        arr.push(obj);
      });
      const object = {
        data: arr,
      };
      requestService
        .PostFetch('ccp', url, object)
        .then(() => {
          this.$swal.fire({
            icon: 'success',
            title: 'Folder has been saved',
            showConfirmButton: false,
            timer: 1500,
          });
          let sort = {
            sortField: 'no',
            params: {
              sortType: 'asc',
            },
          };
          this.loadItems(sort);
          this.edit = !this.edit;
        })
        .catch((err) => {
          this.$swal.fire({
            icon: 'error',
            title: 'Try Again',
            text: err,
            filterParam: '',
          });
        });
    },
    removeAttachment(i) {
      this.attachments.splice(i, 1);
    },
    removeNewAttachment(i) {
      this.new_attachments.splice(i, 1);
    },
    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return '0 Bytes';
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]
        }`;
    },
    downloadFile(filename, type, base64, size, from, mail_id) {
      if (from == 'external') {
        const downloadLink = document.createElement('a');
        var file = base64;
        var filename = filename;
        var blob = new Blob([file]);
        var url = URL.createObjectURL(blob);
        downloadLink.href = url;
        downloadLink.download = filename;
        downloadLink.click();
      } else {
        let object = {
          id: mail_id,
          from: from,
          contentType: type,
          size: size.toString(),
          name: filename,
        };
        let url = `/api/mail/download/file`;
        requestService
          .PostFetch('ccp', url, object)
          .then((response) => response.blob())
          .then((blob) => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            link.click();
          })
          .catch((err) => {
            this.$swal.fire({ icon: 'error', title: 'Try Again', text: err });
          });
      }
    },
    openUpload() {
      this.$refs.fileUpload.click();
    },
    addFile(event) {
      if (event.target.files[0].size == 0) {
        this.$swal.fire({
          icon: 'error',
          title: 'Try Again',
          text: 'ไม่สามารถเลือกไฟล์ว่างเปล่าได้',
        });
        return;
      }
      if (event.target.files[0].size > 12000000) {
        this.$swal.fire({
          icon: 'error',
          title: 'Try Again',
          text: 'ไม่สามารถเลือกไฟล์ที่มีขนาด มากกว่า 12 MB ได้',
        });
        return;
      }
      const file = {
        file: event.target.files[0],
        size: event.target.files[0].size,
        type: event.target.files[0].type,
        name: event.target.files[0].name,
        contentType: event.target.files[0].type,
        contentBytes: event.target.files[0],
        from: 'external',
      };
      this.new_attachments.push(file);
    },
    deleteRow(value) {
      const url = `/api/mail/template/${value.row._id}`;
      this.$swal
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2971FF',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
        })
        .then((result) => {
          if (result.isConfirmed) {
            requestService
              .DeleteFetch('ccp', url)
              .then(() => {
                this.$swal.fire(
                  'Deleted!',
                  'Your file has been deleted.',
                  'success'
                );
                this.loadItems();
              })
              .catch((err) => {
                this.$swal.fire({
                  icon: 'error',
                  title: 'Try Again',
                  text: err,
                });
              });
          }
        });
    },
    async folderOption() {
      let url = `/api/mail/folder/all`;
      const resFolder = await requestService.GetFetch('ccp', url);
      const folder = await resFolder.json();
      this.folder = folder.data;
    },
    onSave(value) {
      let data = this.form.map((item) => item.value);
      this.show = !this.show;
      const url = `/api/mail/template${value.title.match('Edit') ? '/' + value.row.row._id : ''
        }`;
      data[4] = data[4].replaceAll(' ', '&nbsp;');
      data[4] = data[4].replaceAll('\t', '&nbsp;&nbsp;&nbsp;&nbsp;');
      data[4] = data[4].replaceAll('<img&nbsp;', '<img ');
      data[4] = data[4].replaceAll('<strong&nbsp;', '<strong ');
      data[4] = data[4].replaceAll('<span&nbsp;', '<span ');
      data[4] = data[4].replaceAll('color:&nbsp;', 'color:');

      data[4] = data[4].replaceAll('<p&nbsp;class=', '<p class=');
      data[4] = data[4].replaceAll('<p class="ql-indent-1">', '<p>&emsp;&emsp;');
      data[4] = data[4].replaceAll('<p class="ql-indent-2">', '<p>&emsp;&emsp;&emsp;');
      data[4] = data[4].replaceAll('<p class="ql-indent-3">', '<p>&emsp;&emsp;&emsp;&emsp;&emsp;');
      data[4] = data[4].replaceAll('<p class="ql-indent-4">', '<p>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;');
      data[4] = data[4].replaceAll('<p class="ql-indent-5">', '<p>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;');

      data[4] = data[4].replaceAll('<a&nbsp;href=', '<a href=');
      data[4] = data[4].replaceAll('&nbsp;rel=', ' rel=');
      data[4] = data[4].replaceAll('&nbsp;target=', ' target=');
      data[4] = this.replaceColor(data[4]);

      data[4] = data[4].replaceAll('<pre&nbsp;', '<pre ');
      data[4] = data[4].replaceAll('&nbsp;spellcheck=', ' style="background-color: #23241f;color: #f8f8f2;overflow: visible;" spellcheck=');
      data[4] = data[4].replaceAll('<p&nbsp;class=', '<p class=');
      data[4] = data[4].replaceAll('class="ql-align-right"', 'style="text-align: right;"');
      data[4] = data[4].replaceAll('class="ql-align-center"', 'style="text-align: center;"');
      data[4] = data[4].replaceAll('class="ql-align-justify"', 'style="text-align: justify;"');
      data[4] = data[4].replaceAll('class="ql-size-small"', 'style="font-size: 0.75em;"');
      data[4] = data[4].replaceAll('class="ql-size-large"', 'style="font-size: 1.5em;"');
      data[4] = data[4].replaceAll('class="ql-size-huge"', 'style="font-size: 2.5em;"');
      data[4] = data[4].replaceAll('noopener&nbsp;noreferrer', 'noopener noreferrer');

      data[4] = data[4].replaceAll(
        'style="cursor:&nbsp;nwse-resize;"',
        ' style="cursor: nwse-resize;"'
      );

      data[4] = data[4].replaceAll('&nbsp;width=', ' width=');
      let formData = new FormData();
      formData.append('name', data[0]);
      formData.append('folder_id', data[1]._id);
      formData.append('subject', data[2]);
      formData.append('body', data[4]);
      formData.append('file_list', JSON.stringify(this.attachments));
      this.new_attachments.forEach((element) => {
        formData.append('files', element.file);
      });
      requestService
        .PostFetch('ccp', url, formData, 'form-data')
        .then(() => {
          this.$swal.fire({
            icon: 'success',
            title: 'Template has been saved',
            showConfirmButton: false,
            timer: 1500,
          });
          this.form.map((item, i) => {
            this.form[i].value = '';
          });
          this.attachments = [];
          this.new_attachments = [];
          this.loadItems();
        })
        .catch((err) => {
          this.$swal.fire({
            icon: 'error',
            title: 'Try Again',
            text: err,
            filterParam: '',
          });
        });
    },
    openModal(value, id) {
      this.modalData.title = value;
      this.modalData.row = id;
      this.show = !this.show;
      if (!value.match('Add')) {
        // this.form[0].value = id.row.no;
        this.form[0].value = id.row.name;
        this.form[1].value = this.folder.find(
          (item) => item._id === id.row.folder_id
        );
        this.form[2].value = id.row.subject;
        this.form[4].value = id.row.body;
        if (id.row.file != null) {
          this.attachments = id.row.file;
          this.attachments.forEach((element) => {
            element.contentType = element.content_type;
          });
        }
      } else {
        this.attachments = [];
        this.new_attachments = [];
      }
      value.match('View')
        ? (this.modalData.disable = true)
        : (this.modalData.disable = false);
    },
    async loadItems(event) {
      var str = '';
      if (event != undefined) {
        for (var key in event.params) {
          if (key == 'sortType' && event.params[key] == '') {
            event.params[key] = 'asc';
          }
          if (str != '') {
            str += '&';
          }
          str += key + '=' + encodeURIComponent(event.params[key]);
        }
        if (event.sortField != '') {
          this.columns.forEach((element) => {
            if (event.sortField == element.field) {
              if (
                event.sortField == 'created_at' ||
                event.sortField == 'updated_at'
              ) {
                str += '&' + 'sortField=' + event.sortField;
              } else {
                str += '&' + 'sortField=' + element.field;
              }
            }
          });
        } else {
          str += '&' + 'sortField=no';
        }
        if (event.filter != undefined) {
          for (var key in event.filter) {
            if (str != '') {
              str += '&';
            }
            str += key + '=' + encodeURIComponent(event.filter[key]);
          }
        }
      }
      if (str == '') {
        str = 'sortField=no&sortType=asc';
      }
      var url = '/api/mail/template/filter?' + str;
      this.exportDetail.exportUrl = '/api/mail/template/export?' + str;
      return requestService.GetFetch('ccp', url).then((response) => {
        if (response.status == 200) {
          response.text().then((text) => {
            let self = this;
            self.rows = [];
            const data = text && JSON.parse(text);
            if (data.data.data != null) {
              self.json_data = data.data.data;
              data.data.data.forEach((element) => {
                if (element.file != undefined) {
                  element.file.forEach((item) => {
                    item.from = 'internal';
                  });
                }
              });
              self.rows = data.data.data;
              self.$refs.refDataTable.setTotalRecords(data.data.total);
              self.$refs.refDataTable.setPages(data.data.current_page);
            } else {
              self.$refs.refDataTable.setTotalRecords(0);
              self.$refs.refDataTable.setPages(1);
            }
          });
        }
      });
    },
    replaceColor(text) {
      var pos = 0;
      while (true) {
        let result = text.indexOf("rgb", pos);
        //console.log("result",result);
        if (result == -1) {
          break;
        }

        let result1 = text.indexOf(");", result);
        //console.log("result1",result1);

        const raw = text.substring(result, result1);
        //console.log("raw",raw,typeof raw);
        //const rawReplace = raw.toString().replaceAll("&nbsp;", "");
        const rawReplace = raw.split('&nbsp;').join('');
        //console.log("rawReplace",rawReplace);
        text = text.replace(raw, rawReplace);
        //console.log("text",text);
        let result2 = text.indexOf(rawReplace, pos);
        //console.log("result2",result2);
        //console.log("new location",result2+1);
        pos = result2 + 1;
      }
      //console.log("x",x);
      return text;
    },
  },
};
</script>

<style></style>
